<form (ngSubmit)="submitForm()">
  <mat-card class="mat-elevation-z content">
    <h2>Modification du stock de l'article '{{ ligne.article.designation }}'
    </h2>
    <p>
      Le stock actuel est de {{ ligne.qte_stock }}
    </p>
    <mat-radio-group [(ngModel)]="operation" [ngModelOptions]="{standalone: true}" (change)="calculQte()" class="flex gap-5">
      <mat-radio-button value="+">Augmenter le stock</mat-radio-button>
      <mat-radio-button value="-">Diminuer le stock</mat-radio-button>
    </mat-radio-group>
    <mat-form-field class="large">
      <mat-label>{{labelQuantite}}</mat-label>
      <input matInput placeholder="Saisir la quantité" [formControl]='stockControl' type='number' (change)="calculQte()">
      <mat-error *ngIf="stockControl.hasError('required')">
        Vous devez saisir une quantité
      </mat-error>
    </mat-form-field>
    <mat-card-actions>
      <button mat-raised-button type="submit">Enregistrer</button>
    </mat-card-actions>
    <p>*Vous serez contacté d'ici quelques jours pour valider votre demande.</p>
  </mat-card>

  <p class="info">Pour les demandes exceptionnelles merci de <a routerLink="/contact-us"> nous contacter</a>.</p>
</form>